import { required, shape, fromModel, email, when } from '@totalsoft/pure-validations';

const userValidator = fromModel(model =>
  shape({
    name: email,
    partnerId: required,
    personId: required |> when(!model.useNewPerson),
    personFirstName: required |> when(!model.personId),
    personLastName: required |> when(!model.personId),
    personUniqueId: required |> when(!model.personId)
  })
);

export { userValidator };
